/* eslint-disable react/prop-types */
import { useState, useEffect, useRef } from "react";
import { makeId } from "../utils/id";
import "./AddElement.css";
// import convertTableToJSON from "./GeminiAPI/TableConverter.jsx";

//DB imports
import { auth, db } from "../../firebaseConfig";
import { doc, updateDoc, getDoc } from "firebase/firestore";
//Tiptap imports
// import textIcon from "../assets/icons/text.svg";
// import chartIcon from "../assets/icons/chart.svg";
import numbersIcon from "../assets/icons/numbers.svg";
import { processUploadedFile } from "../utils/fileProcessor";
import UploadPasteBlock from "./DropZone/UploadPasteBlock";
import GooglePicker from "./GooglePicker/GooglePicker";

import { onAuthStateChanged } from "firebase/auth";


function AddElement({ viewId, slideId, defaultMenuOpen = false, onElementCreated }) {
  const [menuOpen, setMenuOpen] = useState(defaultMenuOpen);
  const [selectedColumns, setSelectedColumns] = useState(null);
  const [selectedComponentType, setSelectedComponentType] = useState(null);
  const menuRef = useRef(null);

  const [isProcessingFile, setIsProcessingFile] = useState(false);
  const [agentMode, setAgentMode] = useState(false);
  const [isGooglePickerOpen, setIsGooglePickerOpen] = useState(false);
  const [oauthToken, setOauthToken] = useState(null);
  const [userID, setUserID] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserID(user.uid);
      } else {
        console.log("No user is signed in.");
        setUserID(null);
      }
    });
    return () => unsubscribe();
  }, []);
  
  const aiIconSvg = `<span style="margin: 5px;"><svg height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M19.89,9.55A1,1,0,0,0,19,9H14V3a1,1,0,0,0-.69-1,1,1,0,0,0-1.12.36l-8,11a1,1,0,0,0-.08,1A1,1,0,0,0,5,15h5v6a1,1,0,0,0,.69.95A1.12,1.12,0,0,0,11,22a1,1,0,0,0,.81-.41l8-11A1,1,0,0,0,19.89,9.55ZM12,17.92V14a1,1,0,0,0-1-1H7l5-6.92V10a1,1,0,0,0,1,1h4Z"></path></svg></span>`;

  const textIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="36px" height="36px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-type"><polyline points="4 7 4 4 20 4 20 7"></polyline><line x1="9" y1="20" x2="15" y2="20"></line><line x1="12" y1="4" x2="12" y2="20"></line></svg>'
  const chartIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="36px" height="36px" viewBox="0 0 24 24"><path fill="currentColor" d="M12 6a1 1 0 0 0-1 1v10a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1m-5 6a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1m10-2a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1m2-8H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z"/></svg>'
  const diagramIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="36px" height="36px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="3" width="6" height="6"></rect><rect x="2" y="15" width="6" height="6"></rect><rect x="16" y="15" width="6" height="6"></rect><line x1="12" y1="9" x2="12" y2="12"></line><line x1="5" y1="12" x2="19" y2="12"></line><line x1="5" y1="12" x2="5" y2="15"></line><line x1="19" y1="12" x2="19" y2="15"></line></svg>'
  const numbersIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="59" height="56" viewBox="0 0 59 56"><g fill="currentColor" fill-rule="evenodd" stroke="currentColor" stroke-width="2"><path d="M14 19h13v10H14zM27 19h13v10H27zM14 29h13v10H14zM27 29h13v10H27z"/><path d="M14 19v-8a5 5 0 0 1 5-5h3a5 5 0 0 1 5 5v8m-13 20v8a5 5 0 0 0 5 5h3a5 5 0 0 0 5-5v-8m13-20v-8a5 5 0 0 1 5-5h3a5 5 0 0 1 5 5v8M27 39v8a5 5 0 0 0 5 5h3a5 5 0 0 0 5-5v-8"/></g></svg>'

  const actions = [
    { type: "text-editor", icon: textIcon, label: "Text Editor" },
    { type: "data-visualization", icon: chartIcon, label: "Data Visual" },
    { type: "diagram", icon: diagramIcon, label: "Diagram" },
    { type: "data-sig", icon: numbersIcon, label: "Significance" },
  ];

  const columnOptions = [1, 2, 3];

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    // Optionally reset selections when toggling the menu
    setSelectedColumns(null);
    setSelectedComponentType(null);
  };

  useEffect(() => {
    if (menuOpen && menuRef.current) {
      const timer = setTimeout(() => {
        menuRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [menuOpen]);

  //=========== Add Component Function
  const handleAddComponent = async () => {
    if (!selectedColumns || !selectedComponentType) return;

    // const newRowId = componentIdIncrement + 1;
    const initialEditorContent = "<h2>Enter title</h2><p>Description goes here.</p>";
    console.log("Initial Editor Content: ", initialEditorContent);
    // const newComponents = [];

    // for (let i = 0; i < selectedColumns; i++) {
    // const suffix = String.fromCharCode(65 + i); // 'A', 'B', 'C', ...
    const newId = makeId(10);
    // const newSlide = `position-${newRowId}${suffix}`;

    let content = null;
    if (selectedComponentType === "text-editor") {
      content = initialEditorContent;
    } else if (selectedComponentType === "data-visualization") {
      content = "{}"; // Use an empty object
    } else if (selectedComponentType === "diagram") {
      content = "graph LR \n A[Start] --> B{Is it?}; \n B -- Yes --> C[OK]; \n C --> D[Rethink]; \n D --> A; \n B -- No --> E[End]; \n ";
    } else if (selectedComponentType === "data-sig") {
      content = "{}"; // Use an empty object
    }
    // console.log(`Component ${newSlide} initialized with content: `, content);
    console.log(`Component ${newId} initialized with content: `, content);
    setMenuOpen(!menuOpen);

    const newComponent = {
      type: selectedComponentType,
      id: newId,
      cards: selectedColumns,
      content: content,
    };
    // }

    // Save the updated components array to Firestore
    // await saveComponentsToFirestore(newComponents, newRowId);
    await saveComponentsToFirestore(newComponent);

    // setComponents((prevComponents) => [...prevComponents, ...newComponents]);
    // setNewComponents([...newComponents]);
    // setComponentIdIncrement(newRowId); // Update the ID increment state
    // setSelectedColumns(null);
    // setSelectedComponentType(null);
    // window.location.reload();

    await saveComponentIdsToSlide(newComponent.id);

    // Call the onElementCreated callback
    if (onElementCreated) {
      onElementCreated(newId);
    }
  };

  const saveComponentsToFirestore = async (newComponents, fileDataToMerge = null) => {
    const docRef = doc(db, "views", viewId);
    
    try {
      const docSnap = await getDoc(docRef);
      if (!docSnap.exists()) {
        console.error("Error saving component to Firestore. View not found:", viewId);
        return;
      }

      const data = docSnap.data();
      let contentsArray = data.contents ?? [];

      const componentsToSave = Array.isArray(newComponents) ? newComponents : [newComponents];

      componentsToSave.forEach(component => {
        const index = contentsArray.findIndex((c) => c.id === component.id);
        if (index !== -1) {
          contentsArray[index] = component; // Update existing
        } else {
          contentsArray.push(component); // Add new
        }
      });
      
      const updatePayload = {
          contents: contentsArray,
          lastModified: new Date().toISOString()
      };

      if (fileDataToMerge) {
          updatePayload.fileData = { ...(data.fileData || {}), ...fileDataToMerge };
      }

      await updateDoc(docRef, updatePayload);
      console.log("Components and file data updated successfully in Firestore.");

    } catch (error) {
      console.error("Error updating Firestore:", error);
    }
  };

  const saveComponentIdsToSlide = async (newComponentIds) => {
    const docRef = doc(db, "views", viewId);
    
    try {
        const docSnap = await getDoc(docRef);
        if (!docSnap.exists()) {
            console.error("Error saving slide to Firestore. View not found:", viewId);
            return;
        }

        let slidesArray = docSnap.data().slides ?? [];
        const componentIdsToAdd = Array.isArray(newComponentIds) ? newComponentIds : [newComponentIds];

        if (slidesArray.length === 0) {
            slidesArray.push({
                id: slideId || makeId(10),
                components: []
            });
        }

        const slideIndex = slidesArray.findIndex((s) => s.id === slideId);
        const targetSlideIndex = slideIndex !== -1 ? slideIndex : 0;
        
        const currentSlideComponents = slidesArray[targetSlideIndex].components ?? [];
        slidesArray[targetSlideIndex].components = [...currentSlideComponents, ...componentIdsToAdd];
        
        await updateDoc(docRef, { slides: slidesArray, lastModified: new Date().toISOString() });
        console.log("Slides updated successfully in Firestore.");

    } catch (error) {
        console.error("Error updating Firestore:", error);
    }
  };

    // Handler for Google Picker data
    const handleSheetData = (blobs) => {
      const files = blobs.map(blob => {
        let fileName = blob.name;
        if (!fileName.toLowerCase().endsWith('.csv')) {
          fileName += '.csv';
        }
        return new File([blob], fileName, { type: blob.type });
      });
      handleFileDrop(files);
    };

    // Enhanced file drop handler
    const handleFileDrop = async (acceptedFiles) => {
      if (acceptedFiles.length === 0) return;
  
      setIsProcessingFile(true);
  
      try {
        const currentUser = auth.currentUser;
        if (!currentUser) {
          throw new Error("User not authenticated");
        }
  
        const docRef = doc(db, "views", viewId);
        const docSnap = await getDoc(docRef);
  
        if (!docSnap.exists()) {
          throw new Error("View not found");
        }
  
        const viewData = docSnap.data();
        let existingContents = viewData.contents || [];
        let existingSlides = viewData.slides || [];
        let fileData = viewData.fileData || {};
        
        let newComponentIdsForAllFiles = [];
  
        for (const file of acceptedFiles) {
            const structuredData = await processUploadedFile(file);
            
            existingContents.push(...structuredData.contents);
            
            const newComponentIds = structuredData.contents.map(c => c.id);
            newComponentIdsForAllFiles.push(...newComponentIds);
            
            // Merge fileData
            Object.assign(fileData, structuredData.fileData);
        }

        if (existingSlides.length === 0) {
            existingSlides.push({
                id: slideId || makeId(10),
                components: []
            });
        }

        const slideIndex = existingSlides.findIndex((s) => s.id === slideId);
        const targetSlideIndex = slideIndex !== -1 ? slideIndex : 0;
        
        const currentSlideComponents = existingSlides[targetSlideIndex].components ?? [];
        existingSlides[targetSlideIndex].components = [...currentSlideComponents, ...newComponentIdsForAllFiles];

        await updateDoc(docRef, {
          contents: existingContents,
          slides: existingSlides,
          fileData: fileData,
          lastModified: new Date().toISOString(),
        });
  
        if (onElementCreated) {
          onElementCreated(newComponentIdsForAllFiles);
        }
  
      } catch (error) {
        console.error("Error processing file:", error);
        alert(`Error processing file: ${error.message}`);
      } finally {
        setIsProcessingFile(false);
        setMenuOpen(false); // Close menu after adding element
      }
    };
  
  return (
    <div className="add-element">
      <button onClick={toggleMenu} className={menuOpen ? "close-menu-Btn" : "open-menu-Btn"}>
        <span className="icon"> {menuOpen ? "+" : "+"}</span>
      </button>




      {menuOpen && (
        <div className="custom-menu-container">
          <div className="custom-menu-content" ref={menuRef}>

            {/* Start a new view */}          

          <div className="cards"> 

          <h4 className="cards-group-header">Smart build</h4>
          
                     <div className="btns">

          <button className="homeBTN" style={{ paddingLeft: '12px', paddingRight: '12px' }}>
              <UploadPasteBlock
              onFileDrop={handleFileDrop}
              // onPaste={(pastedData) => {
              //   // Convert the pasted data to structured data if needed
              // }}
              isProcessingFile={isProcessingFile}
            />
           </button>

             <button
                  className="homeBTN"
                  onClick={() => setIsGooglePickerOpen(true)}
                >
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', justifyContent: 'center' }}>
                <img src="../../icons/Google_Sheets_logo.svg" alt="Google Sheets" style={{ borderRadius: '0px', width: '48px', height: '64px', marginBottom: '24px' }} />
                <img src="../../icons/google-tile.svg" alt="Google Sheets" style={{ width: '64px', height: '64px', marginBottom: '16px' }} />
                
                </div>
                Connect to Google Sheets

                </button>
          </div>
          </div>

          <div style={{ alignContent: 'center', flexDirection: 'row', display: 'flex', justifyContent: 'center', textAlign: 'center', marginBottom: '24px' }}>
          <div style={{height: '1px', width: "100%", borderBottom: '1px solid var(--Grey2)', margin: "22px 24px 16px 24px"}}/><p className="overline"> OR </p> <div style={{height: '1px', width: "100%", borderBottom: '1px solid var(--Grey2)', margin: "22px 24px 16px 24px"}}/>
          </div>

           <div className="cards"> 
           <h4 className="cards-group-header">Add a card</h4>

            <div className="column-selection">
              <p className="menuTxt">How many columns?</p>
              {columnOptions.map((columns) => (
                <button
                  key={columns}
                  onClick={() => setSelectedColumns(columns)}
                  style={{ width: "31%", height: "64px" }}
                  className={`btn ${columns <= selectedColumns ? "active" : ""}`}
                >
                  {columns} Column{columns > 1 ? "s" : ""}
                </button>
              ))}
            </div>
            <hr className="menuHr" />
            <div className="component-selection">
              <p className="menuTxt">What type?</p>
              {actions.map((action) => (
                <button
                  // style={{height:'64px', paddingTop:'-12px'}}
                  key={action.type}
                  onClick={() => setSelectedComponentType(action.type)}
                  className={`btn ${selectedComponentType === action.type ? "active" : ""}`}
                >
                  <span
                    className="action-icon"
                    style={{ borderRadius: "0", display: "flex", alignItems: "center", marginRight: "8px" }}
                    dangerouslySetInnerHTML={{ __html: action.icon }}
                  />
                  {action.label}
                </button>
              ))}
            </div>
            <button className="build-element" onClick={handleAddComponent} disabled={!selectedColumns || !selectedComponentType}>
              Add card
            </button>
          </div>
          {/* <div className="custom-menu-background" onClick={toggleMenu}></div> */}
        </div>
        </div>
      )}
      
            <GooglePicker
              isRequested={isGooglePickerOpen}
              onCSVBlobsCreated={handleSheetData}
              onClose={() => setIsGooglePickerOpen(false)}
              oauthToken={oauthToken}
              setOauthToken={setOauthToken}
            />
      
    </div>
    
  );
}

export default AddElement;
